import { useCallback } from 'react'

import type { IAutoReviewMissingField } from '@user/store/draftLeads/typings'
import { validateUpdateRequiredFields } from '@user/features/PendingLeadAutoReview/utils/validateUpdateRequiredFields'

import type { LeadExtraFieldKey } from '../utils/mapMissingFieldsToForm'
import type { LeadCompanyRequiredFieldsFormValues } from './useInitialValues'

type Props = {
  fields: IAutoReviewMissingField[]
  extraKeys: LeadExtraFieldKey[]
}

const REQUIRED = 'Required'

/** Formik `validate`: every rendered field is required; referral is never validated. */
export function useValidate(props: Props) {
  const { fields, extraKeys } = props

  return useCallback(
    (values: LeadCompanyRequiredFieldsFormValues) => {
      const errors: Record<string, unknown> = {
        ...validateUpdateRequiredFields(values, fields),
      }

      if (
        extraKeys.includes('preferredMethodOfContact') &&
        !values.preferredMethodOfContact
      )
        errors.preferredMethodOfContact = REQUIRED
      if (
        extraKeys.includes('preferredTimeOfContact') &&
        values.preferredTimeOfContact.length === 0
      )
        errors.preferredTimeOfContact = REQUIRED
      if (extraKeys.includes('nextActionDate') && !values.nextActionDate)
        errors.nextActionDate = REQUIRED

      return errors
    },
    [fields, extraKeys],
  )
}
